export class Threshold {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "mode",
            "baseName": "mode",
            "type": "ThresholdMode",
            "format": ""
        },
        {
            "name": "steps",
            "baseName": "steps",
            "type": "Array<ThresholdStep>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Threshold.attributeTypeMap;
    }
    constructor() {
    }
}
